export default __webpack_public_path__ + "static/media/add-portfolio-plus-icon.56a7a9b0.svg";